module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-derma-k_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/vyhlazeni-vrasek-metodou-derma-k_1_after.jpg
// module id = 1249
// module chunks = 0